//
// forms/js-mkto-form.js
//
// Instantiates our regular forms, with all bells & whistles enabled:
//
// - creates the submission controller
// - creates the ui controller (js-mkto-form-ui)
// - and instantiates other form functionality:
//     - prefill
//     - progressive
//     - industry dropdown functionality
//     - attaches callbacks to be ran after successful submission
//
// - Note: We save the values of some fields (like email, name etc) in to
//   local storage when certain form modes are activated. At present,
//   we consider submitting a form to be a form of consent - so this functionality
//   is NOT currently disabled/enabled via the cookie consent system.
//
// - Note 23/06/21: Not sure this file needs any affiliation to marketo.
//   For example, it's currently being used for BuzzSumo's contact form.

import ui                                from './js-mkto-form-ui';
import submission                        from './submission';
import run_progressive_profiling         from './progressive-profiling';
import run_industry_select_functionality from './industry-select-functionality';
import run_field_visibility              from './js-mkto-field-visibility';
import run_drift_fast_lane               from './drift-fast-lane';
import run_content_download_saver        from './content-dowload-submission-saver';
import run_enhanced_conversion           from './enhanced_conversion';
import run_prefill                       from './prefill';
import run_gdpr                          from './gdpr';
import {data_store}                      from './data-store';
import {chain}                           from '../helpers/functional';
import * as site_lang                    from '../site-lang';


// init_all()
// -------------------------------------

function init_all() {
  const forms = Array.from(document.getElementsByClassName('js-mkto-form'));
  forms.forEach(chain(ui, load));
}
init_all();



// load(el_form)
// -------------------------------------

function load(el_form) {
  const submission_ctrlr = submission(el_form);

  if (!site_lang.is_de()) {
    run_gdpr(el_form);
  }

  // Progressive Profiling
  // -------------------------------------
  // Hide AND prefill inputs that have we already have data for
  // NB: only if el_form has data-progressive

  run_progressive_profiling(el_form);


  // Prefill
  // -------------------------------------
  // JUST Prefill inputs that we already have data for
  // NB: only if el_form has data-prefill

  run_prefill(el_form);


  // Field Visibility
  // -------------------------------------
  // Conditionallly show and hide fields based on the value of another field
  // NB: only if any fields have data-visibility-controlled-field

  run_field_visibility(el_form);


  // Experiemental - Idustry Dropdown Functionality
  // -------------------------------------
  // Redirect to a different location if el_form has an idustry select field
  // Needs more work - has non form specific logic in (image/logo changer)

  run_industry_select_functionality(el_form);


  // Loose validate on page load
  el_form.dispatchEvent(new CustomEvent('Form/LooseValidate', {detail: el_form}));


  // After successful submission
  // -------------------------------------
  // Run funcs via submission_ctrlr.register__on_success()

  submission_ctrlr.register__on_success(run_content_download_saver);
  submission_ctrlr.register__on_success(run_enhanced_conversion);
  submission_ctrlr.register__on_success(run_drift_fast_lane); // modifies redirect - needs to be run last
}

